<template>
  <div id="basic_info">
    <div class="repay_pwd pay_pwd_form">
      <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="118px" class="demo-ruleForm pay-pwd-form">
        <el-form-item label="手机号：" prop="ph_num">
          <div class="personal_info">
            {{infoForm.ph_num}}
          </div>
        </el-form-item>
        <el-form-item label="短信验证码：" prop="v_code" class="v_code">
          <el-input placeholder="请输入短信验证码" autocomplete="new-password" v-model="infoForm.v_code" class="v_code_input"></el-input>
          <div v-if="smsCode" class="v_code_btn" @click="sentVCode">获取</div>
          <div v-else class="v_code_btn" id="smsFalse">{{ smsTime }}s</div>
        </el-form-item>
        <el-form-item label="支付密码：" prop="pay_pwd">
          <el-input placeholder="请输入支付密码" autocomplete="new-password" v-model="infoForm.pay_pwd" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="repay_pwd">
          <el-input placeholder="请确认支付密码" autocomplete="new-password" v-model="infoForm.repay_pwd" show-password></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-row">
        <div class="submit_btn" @click="submitForm('infoForm')">确认提交</div>
      </div>
    </div>
  </div>
</template>
<script>
import {apiSmsSend,apiUserPaypwd,apiuserInfo} from "@/request/API";


export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    var validatePayPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入支付密码'))
      } else if (value !== this.infoForm.pay_pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      //头像
      imageUrl: '',
      //上传按钮文本
      elUploadBtn:'点击上传',
      //是否有支付密码
      pwdState:false,
      //支付密码 展示用
      showPaypwd:this.$store.state.userData.paypwd,
      //表单
      infoForm:{
        ph_num:this.$store.state.userData.telphone,
        v_code:'',
        pay_pwd:'',
        repay_pwd:''
      },
      //表单验证
      rules: {
        v_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        pay_pwd: [
          { required: true, message: '请输入支付密码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '密码由6位数字组成' }
        ],
        repay_pwd: [
          { required: true, validator: validatePayPwd, trigger: 'blur' }
        ]
      },
      //获取验证码
      smsCode:true,
      smsTime:60
    }
  },
  methods: {
    //头像上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isJPG  && isLt5M;
    },

    //发送验证码
    sentVCode(){
      if (this.$store.state.userData.country_code !== '86') {
        this.$message({
          type:'error',
          center:true,
          message:'国际用户暂不支持设置或修改支付密码，请联系客服换绑'
        })
        return
      }
      apiSmsSend({
        phone:this.$store.state.userData.telphone,
        codeType:8,
        country_code:this.$store.state.userData.country_code
      }).then(res=>{
        this.$message({
          type:"success",
          center:true,
          message:"发送成功"
        })
        this.smsCode = false
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })
    },
    //重设密码
    changePaypwd(){
      this.pwdState = !this.pwdState
    },
    //表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiUserPaypwd({
            paypwd:this.infoForm.pay_pwd,
            paypwd_confirm:this.infoForm.repay_pwd,
            smsCode:this.infoForm.v_code,
          }).then(res=>{
            this.$store.commit('user_paypwd',this.infoForm)
            this.$message({
              message: "设置成功",
              type: 'success',
              center: true
            });
            this.$refs[formName].resetFields();
            this.pwdState = true
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error',
              center: true
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取 支付密码 信息
    getBasicInfo(){
      apiuserInfo({
        action:'base'
      }).then(res=>{
      })
    },
    //获取验证码冷却
    countdownTime(){
      this.smsTime--
      if(this.smsTime === 0){
        this.smsCode = true
      }
    }
  },
  mounted () {
    //判断user是否有支付密码
    if(this.$store.state.userData.paypwd !== ''){
      this.pwdState = true
    }else {
      this.pwdState = false
    }
  },
  watch: {
    smsCode(val, oldVal){//普通的watch监听
      if(!val){
        this.smsTime = 60
        this.countdown = setInterval(this.countdownTime, 1000);
      }else{
        clearInterval(this.countdown)
      }
    },
    imageUrl(){
      if (this.imageUrl !== '') {
        this.elUploadBtn = '重新上传'
      }
    }
  },
  computed: {

  },
  created() {
    if (localStorage.getItem('loginStatus') == "true") {
      this.infoForm.ph_num = JSON.parse(localStorage.getItem('userData')).telphone
    }
  }
}
</script>


<style lang='less' scoped>
#basic_info{
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .pay_pwd_form{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .pay-pwd-form{
      display: table;
      width: auto;
      max-width: 100%;
      margin: 0 auto;
    }

    /deep/.el-form-item{
      min-height: 40px;
      margin-bottom: 22px;
    }

    /deep/.el-form-item__content{
      min-height: 40px;
      line-height: 40px;
    }

    /deep/.el-input{
      width: 360px;
      max-width: 100%;
    }

    /deep/.el-input__inner{
      width: 100%;
      height: 40px;
      padding: 0 14px;
      background: var(--bg-tag, #F7F5F2);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
    }

    /deep/.el-input__inner:hover{
      border-color: var(--border-strong, #D8D2CA);
      background: #FFFFFF;
    }

    /deep/.el-input__inner:focus{
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }

    /deep/.is-error .el-input__inner{
      border-color: var(--danger, #EF4444);
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
    }

    /deep/.el-form-item__error{
      padding-top: 5px;
      color: var(--danger, #EF4444);
    }

    .v_code /deep/.el-form-item__content{
      display: flex;
      align-items: flex-start;
    }

    .v_code_input,
    .v_code_input /deep/.el-input__inner{
      width: 246px;
    }

    .v_code_btn{
      margin: 0 0 0 10px !important;
      width: 104px;
      height: 40px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      border-radius: 3px;
      background: #FFFFFF;
      color: var(--text-main, #1A1D24);
      cursor: pointer;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      line-height: 38px;
      transition: color .2s ease, background .2s ease, border-color .2s ease;
    }

    .v_code_btn:hover{
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    #smsFalse{
      color: var(--text-muted, #9AA0AC);
      border-color: var(--border-soft, #E8E4DE);
      background: var(--bg-tag, #F0EDE8);
      cursor: auto;
    }

    #smsFalse:hover{
      border-color: var(--border-soft, #E8E4DE);
      background: var(--bg-tag, #F0EDE8);
    }

    /deep/.el-form-item__label{
      padding: 0 16px 0 0;
      text-align: right;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 40px;
    }

    .personal_info{
      display: flex;
      width: 360px;
      max-width: 100%;
      min-height: 40px;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
    }

    .submit-row{
      width: 584px;
      max-width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }

    .submit_btn{
      margin: 8px 0 0 0;
      width: 200px;
      height: 42px;
      line-height: 42px;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      box-shadow: none;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
      transition: background .2s ease;
    }

    .submit_btn:hover{
      background: var(--primary-hover, #E84A12);
    }
  }

}
</style>
